<template>
<div>
    <div class="mb-5">
        <history-files-section></history-files-section>
    </div>
</div>
</template>

<script>
import HistoryFilesSection from '@/components/shared/HistoryFilesSection.vue'
import { MENU_PATH, DOCUMENTS_HISTORY_PATH } from '@/constants/clinicHistory'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'
import BaseButton from '../../base/buttons/BaseButton.vue'

export default {
    components: {
        HistoryFilesSection,
        BaseButton
    },
    mixins: [clinicHistoryMixin],
    data () {
        return {
            MENU_PATH,
            DOCUMENTS_HISTORY_PATH
        }
    }
}
</script>

<style style="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/views/clinicHistory/ClinicHistoryFiles.vue